import { useKeycloakAuth } from '@shared/hooks/useKeycloakAuth';
import { useTranslationHelper } from '@shared/hooks/useTranslationsHelper';
import { selectAuth } from '@shared/store/auth/auth.selectors';
import { selectContributionsStatus, selectDisabilitiesStatus } from '@shared/store/mainMenu/mainMenu.selectors';
import { MdcGrid, MdcSkeleton } from 'ids-wc/dist/react/components';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import NavItem from './NavItem.component';
import { SIDEBAR_CONFIG } from './sidebar-config.helper';
import styles from './Sidebar.module.css';
import efkaLogo from '/efka-logo-horizontal.png';

const Sidebar = () => {
  const auth = useSelector(selectAuth);
  const contributionsStatus = useSelector(selectContributionsStatus);
  const disabilitiesStatus = useSelector(selectDisabilitiesStatus);
  const [menuOptions, setMenuOptions] = useState((auth.userType && SIDEBAR_CONFIG[auth.userType]) || []);

  const { logout } = useKeycloakAuth();

  const { t } = useTranslationHelper('sidebar');

  useEffect(() => {
    const isLoading = contributionsStatus.areContributionsLoading;
    const isHidden = !contributionsStatus.areContributionsLoading && !contributionsStatus.areContributionsEnabled;

    setMenuOptions((prev) =>
      prev.map((option) => (option.id === 'contributions' ? { ...option, isHidden, isLoading } : option))
    );
  }, [contributionsStatus.areContributionsEnabled, contributionsStatus.areContributionsLoading]);

  useEffect(() => {
    const isLoading = disabilitiesStatus.areDisabilitiesLoading;
    const isHidden = !disabilitiesStatus.areDisabilitiesLoading && !disabilitiesStatus.areDisabilitiesEnabled;

    setMenuOptions((prev) =>
      prev.map((option) => (option.id === 'disability' ? { ...option, isHidden, isLoading } : option))
    );
  }, [disabilitiesStatus.areDisabilitiesEnabled, disabilitiesStatus.areDisabilitiesLoading]);

  return (
    <nav className={styles['sidebar-container']}>
      <MdcGrid row>
        <MdcGrid col={12} className={styles['logo-container']}>
          <img src={efkaLogo} alt="EFKA Logo" />
        </MdcGrid>
      </MdcGrid>

      <MdcGrid row>
        <MdcGrid col={12} className={styles['main-nav-items-container']}>
          <NavItem to={'/'} icon="home" iconTitle="home" text={t('home')} />

          {auth.userType &&
            menuOptions
              .filter((val) => !val.isHidden)
              .map((val) =>
                val.isLoading ? (
                  <MdcSkeleton key={val.id} variant="button" buttonLength="full" />
                ) : (
                  <NavItem key={val.id} to={val.path} icon={val.icon!} iconTitle={val.icon} text={t(val.label)} />
                )
              )}
        </MdcGrid>
      </MdcGrid>

      <MdcGrid row>
        <MdcGrid col={12}>
          {auth.isAuthenticated && (
            <NavItem
              icon={'logout'}
              iconTitle={'logout'}
              text={t('logout')}
              additionalWrapperClass="mt-8"
              onClick={logout}
              isLogout
            />
          )}
        </MdcGrid>
      </MdcGrid>
    </nav>
  );
};

export default Sidebar;
